export const IconPause = () => (
  <svg width="40" height="48" viewBox="0 0 40 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M6 0C2.68629 0 0 2.68629 0 6V42C0 45.3137 2.68629 48 6 48C9.31371 48 12 45.3137 12 42V6C12 2.68629 9.31371 0 6 0ZM34 0C30.6863 0 28 2.68629 28 6V42C28 45.3137 30.6863 48 34 48C37.3137 48 40 45.3137 40 42V6C40 2.68629 37.3137 0 34 0Z" fill="white" />
  </svg>
);

export default IconPause;
